"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const primary = {
  lightest: '#F6F6FA',
  lighter: '#C4C4CD',
  light: '#747480',
  main: '#2e2e38',
  dark: '#000000',
  contrastText: '#fff'
};
const secondary = {
  lightest: '#fffde7',
  lighter: '#fff59d',
  light: '#fff17c',
  main: '#ffe600',
  dark: '#ffbf00',
  contrastText: '#2e2e38'
};
const error = {
  lightest: '#FADDDC',
  lighter: '#FF4136',
  light: '#E0362C',
  main: '#B9251C',
  contrastText: '#fff'
};
const success = {
  lightest: '#FBFEFC',
  lighter: '',
  light: '#57E188',
  main: '#168736',
  contrastText: '#fff'
};
const warning = {
  lightest: '#FF9831',
  lighter: '#FF800A',
  light: '#FF6D00',
  main: '#EB4F00',
  contrastText: '#2e2e38'
};
const info = {
  main: '#155CB4'
};
const breakpoints = {
  values: {
    xl: 1920,
    lg: 1280,
    md: 960,
    sm: 600,
    xs: 0
  }
};
const background = {
  paper: primary.contrastText,
  default: primary.contrastText
};
const htmlFontSize = 16;
const fontSize = 14;
const coef = fontSize / 14;

const pxToRem = size => `${size / htmlFontSize * coef}rem`;

const spacing = factor => `${0.5 * factor}rem`;

const typography = {
  htmlFontSize,
  fontSize,
  fontFamily: ['Roboto', 'sans-serif'].join(','),
  button: {
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'none',
    lineHeight: '150%',
    letterSpacing: '0.01em'
  },
  h1: {
    fontSize: `${pxToRem(36)}`,
    fontWeight: 300,
    lineHeight: `${pxToRem(46)}`
  },
  h2: {
    fontSize: `${pxToRem(34)}`,
    fontWeight: 300,
    lineHeight: `${pxToRem(44)}`
  },
  h3: {
    fontSize: `${pxToRem(32)}`,
    fontWeight: 300,
    lineHeight: `${pxToRem(40)}`
  },
  h4: {
    fontSize: `${pxToRem(24)}`,
    fontWeight: 300,
    lineHeight: `${pxToRem(30)}`
  },
  h5: {
    fontSize: `${pxToRem(20)}`,
    fontWeight: 300,
    lineHeight: `${pxToRem(28)}`
  }
};
var _default = {
  palette: {
    primary,
    secondary,
    error,
    success,
    warning,
    info,
    background,
    action: {
      disabled: primary.lighter
    }
  },
  breakpoints,
  shape: {
    borderRadius: 0
  },
  overrides: {
    MuiTypography: {
      body1: {
        fontWeight: 300
      },
      h1: {
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.md)})`]: {
          fontSize: `${pxToRem(40)}`,
          lineHeight: `${pxToRem(50)}`
        },
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.lg)})`]: {
          fontSize: `${pxToRem(48)}`,
          lineHeight: `${pxToRem(60)}`
        }
      },
      h2: {
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.md)})`]: {
          fontSize: `${pxToRem(36)}`,
          lineHeight: `${pxToRem(48)}`
        },
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.lg)})`]: {
          fontSize: `${pxToRem(40)}`,
          lineHeight: `${pxToRem(50)}`
        }
      }
    },
    MuiLink: {
      underlineHover: {
        textDecoration: 'none',
        paddingBottom: `${pxToRem(1)}`,
        '&:hover': {
          textDecoration: 'none',
          borderBottom: `${pxToRem(1)} solid`,
          paddingBottom: 0
        }
      },
      underlineAlways: {
        textDecoration: 'none',
        borderBottom: `${pxToRem(0.8)} solid`,
        paddingBottom: `${pxToRem(1)}`,
        '&:hover': {
          textDecoration: 'none',
          borderBottom: `${pxToRem(1.5)} solid`,
          paddingBottom: 0
        }
      }
    },
    // Button theme for contained and outline
    MuiButton: {
      root: {
        padding: `${pxToRem(13)} ${pxToRem(26)}`,
        '&:disabled': {
          backgroundColor: primary.lightest
        }
      },
      outlinedPrimary: {
        padding: `${pxToRem(12)} ${pxToRem(26)}`,
        border: `${pxToRem(1)} solid ${primary.main}`,
        '&:hover:not(:disabled)': {
          border: `${pxToRem(1)} solid ${primary.main}`,
          backgroundColor: primary.main,
          color: primary.contrastText,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent',
            color: primary.main
          }
        },
        '&:disabled': {
          // remove border and increase padding to compensate in order to keep height at 50px
          border: 'none',
          '&.MuiButton-outlinedSizeSmall': {
            border: `${pxToRem(1)} solid ${primary.lightest}`
          },
          "&:not('.MuiButton-outlinedSizeSmall')": {
            padding: `${pxToRem(13)} ${pxToRem(27)}`
          }
        }
      },
      outlinedSecondary: {
        padding: `${pxToRem(12)} ${pxToRem(26)}`,
        border: `${pxToRem(1)} solid ${secondary.main}`,
        '&:hover:not(:disabled)': {
          border: `${pxToRem(1)} solid ${secondary.main}`,
          backgroundColor: secondary.main,
          color: secondary.contrastText,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent',
            color: secondary.main
          }
        },
        '&:disabled': {
          // remove border and increase padding to compensate in order to keep height at 50px
          border: 'none',
          '&.MuiButton-outlinedSizeSmall': {
            border: `${pxToRem(1)} solid ${primary.lightest}`
          },
          "&:not('.MuiButton-outlinedSizeSmall')": {
            padding: `${pxToRem(13)} ${pxToRem(27)}`
          }
        }
      },
      contained: {
        boxShadow: 'none',
        '&:disabled': {
          // remove border and increase padding to compensate in order to keep height at 50px
          border: 'none',
          '&.MuiButton-containedSizeSmall': {
            border: `${pxToRem(1)} solid ${primary.lightest}`
          },
          "&:not('.MuiButton-containedSizeSmall')": {
            padding: `${pxToRem(13)} ${pxToRem(27)}`
          },
          backgroundColor: primary.lightest
        }
      },
      containedPrimary: {
        padding: `${pxToRem(12)} ${pxToRem(26)}`,
        backgroundColor: primary.main,
        border: `${pxToRem(1)} solid ${primary.lighter}`,
        '&:hover:not(:disabled)': {
          border: `${pxToRem(1)} solid ${primary.lighter}`,
          backgroundColor: primary.contrastText,
          color: primary.main,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: primary.main,
            color: primary.contrastText
          }
        }
      },
      containedSecondary: {
        padding: `${pxToRem(12)} ${pxToRem(26)}`,
        border: `${pxToRem(1)} solid ${secondary.main}`,
        backgroundColor: secondary.main,
        color: secondary.contrastText,
        '&:hover:not(:disabled)': {
          border: `${pxToRem(1)} solid #ccb800`,
          backgroundColor: '#f5de00',
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: secondary.main,
            color: secondary.contrastText
          }
        }
      },
      textPrimary: {
        '&:hover': {
          textDecoration: 'underline'
        }
      },
      sizeLarge: {
        padding: `${pxToRem(13)} ${pxToRem(39)}`
      }
    },
    MuiAppBar: {
      root: {
        boxShadow: 'none',
        height: `${pxToRem(48)}`
      }
    },
    MuiToolbar: {
      regular: {
        minHeight: `${pxToRem(48)}`,
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.sm)})`]: {
          minHeight: `${pxToRem(48)}`
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: primary.main
      }
    },
    MuiToggleButtonGroup: {
      grouped: {
        minHeight: pxToRem(50),
        border: `${pxToRem(1)} solid ${primary.main}`,
        '&:not(:first-child)': {
          borderLeft: `${pxToRem(1)} solid ${primary.main}`
        },
        '&:first-child': {
          borderRadius: `${pxToRem(4)} ${pxToRem(0)} ${pxToRem(0)} ${pxToRem(4)}`
        },
        '&:last-child': {
          borderRadius: `${pxToRem(0)} ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(0)}`
        }
      }
    },
    MuiToggleButton: {
      root: {
        color: primary.main,
        backgroundColor: primary.lightest,
        fontWeight: 500,
        height: 'unset',
        // unset hard-coded height: https://github.com/mui-org/material-ui/blob/0fe179724d345f20a10975a5e291fc40b439549d/packages/material-ui-lab/src/ToggleButton/ToggleButton.js#L16
        // material-ui uses jss-nested plugin for increasing specifity
        // which follows syntax defined on below link
        // https://github.com/cssinjs/jss-nested#use--to-reference-selector-of-the-parent-rule
        '&$selected': {
          backgroundColor: primary.main,
          color: primary.lightest,
          '&:hover': {
            backgroundColor: primary.main,
            color: primary.lightest
          }
        },
        '&$disabled': {
          color: primary.lighter
        }
      },
      selected: {},
      disabled: {}
    },
    MuiPaper: {
      root: {
        padding: spacing(2)
      }
    },
    MuiContainer: {
      maxWidthLg: {
        [`@media only screen and (min-width: ${pxToRem(breakpoints.values.lg)})`]: {
          paddingLeft: spacing(3),
          paddingRight: spacing(3)
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        paddingLeft: pxToRem(16),
        // height should be (at least): 24 + 13 + 13 = 50
        minHeight: pxToRem(24),
        paddingTop: pxToRem(13),
        paddingBottom: pxToRem(13)
      },
      notchedOutline: {
        borderColor: primary.main
      }
    },
    MuiSelect: {
      iconOutlined: {
        right: pxToRem(16)
      },
      outlined: {
        paddingRight: pxToRem(56) // allow space for icon which takes up: 24 width + 2 * 16 padding = 56

      }
    },
    MuiNativeSelect: {
      iconOutlined: {
        right: pxToRem(16)
      }
    },
    MuiChip: {
      root: {
        height: pxToRem(22),
        fontSize: `${pxToRem(12)}`
      }
    },
    MuiPopover: {
      paper: {
        padding: 0
      }
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: primary.contrastText,
        color: primary.main
      }
    },
    MuiDrawer: {
      paper: {
        [`@media only screen and (max-width: ${pxToRem(breakpoints.values.sm)})`]: {
          width: '100%'
        },
        backgroundColor: primary.main,
        color: primary.contrastText,
        padding: 0
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: primary.contrastText
      }
    },
    MuiDialog: {
      paper: {
        padding: spacing(1.5),
        margin: spacing(7),
        boxSizing: 'border-box'
      },
      scrollPaper: {
        alignItems: 'flex-start'
      },
      paperScrollPaper: {
        maxHeight: `calc(100% - ${spacing(7 * 2)})`
      },
      paperWidthSm: {
        maxWidth: pxToRem(600),
        width: pxToRem(600)
      },
      paperWidthMd: {
        maxWidth: pxToRem(720),
        width: pxToRem(720)
      },
      paperWidthLg: {
        maxWidth: pxToRem(1000),
        width: pxToRem(1000)
      }
    },
    MuiDialogTitle: {
      root: {
        padding: `${spacing(1.5)} ${spacing(1.5)} ${spacing(1)}`
      }
    },
    MuiDialogContent: {
      root: {
        padding: spacing(1.5)
      },
      dividers: {
        borderTop: 'none',
        padding: `${spacing(1)} 0 ${spacing(5)}`,
        margin: `0 ${spacing(1.5)}`
      }
    },
    MuiDialogContentText: {
      root: {
        marginBottom: 0
      }
    },
    MuiDialogActions: {
      root: {
        padding: `${spacing(3)} ${spacing(1.5)} ${spacing(1.5)} ${spacing(1.5)}`,
        justifyContent: 'flex-start'
      },
      spacing: {
        '& > :not(:first-child)': {
          marginLeft: spacing(2)
        }
      }
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#1a1a24',
          borderLeft: `4px solid ${secondary.main}`,
          '&:hover': {
            backgroundColor: '#1a1a24'
          }
        },
        '&$disabled': {
          '&:nth-child(even)': {
            backgroundColor: '#EAEAEE'
          },
          '&:nth-child(odd)': {
            backgroundColor: '#EAEAEE'
          }
        }
      }
    },
    MuiMenuItem: {
      root: {
        padding: `${spacing(1.625)} ${spacing(1)}`,
        height: spacing(6.25),
        '&:nth-child(odd)': {
          backgroundColor: '#FAFAFC'
        },
        '&:nth-child(even)': {
          backgroundColor: '#FFFFFF'
        },
        border: `${pxToRem(1)} solid rgba(196, 196, 205, 0.35)`,
        '&$selected': {
          fontWeight: 'bold',
          borderLeft: `${pxToRem(4)} solid ${secondary.main}`,
          '&:hover': {
            borderLeft: `${pxToRem(4)} solid ${secondary.main}`,
            '&:nth-child(odd)': {
              backgroundColor: '#FAFAFC'
            },
            '&:nth-child(even)': {
              backgroundColor: '#FFFFFF'
            }
          }
        },
        '&:hover': {
          border: `${pxToRem(1)} solid ${primary.main}`,
          zIndex: 1,
          boxShadow: `${pxToRem(0)} ${pxToRem(1)} ${pxToRem(5)} rgba(0, 0, 0, 0.12), ${pxToRem(0)} ${pxToRem(2)} ${pxToRem(2)} rgba(0, 0, 0, 0.14), ${pxToRem(0)} ${pxToRem(1)} ${pxToRem(1)} rgba(0, 0, 0, 0.2)`
        }
      }
    },
    MuiCircularProgress: {
      circleIndeterminate: {
        animationDirection: 'reverse'
      },
      indeterminate: {
        animationDirection: 'reverse'
      },
      circle: {
        strokeWidth: '4'
      }
    }
  },
  typography
};
exports.default = _default;